/**
 * Default filter state for the system dashboard.
 */
export const DEFAULT_FILTERS = {
    timeRange: '30days',
    category: 'all',
    start_date: '',
    end_date: '',
    gender: '',
    min_age: '',
    max_age: '',
    min_reactions: '',
    min_comments: '',
    visit_type: '',
    country_id: ''
};
